





























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  METHODS,
  STATUSES,
  SERVICE_PAYMENT_STATUSES,
} from '@/constants/payment';
import ServiceOrderCreateOrderReviewTable from '@/pages/Business/ServiceOrder/Create/ServiceOrderCreateOrderReviewTable.vue';

@Component({
  components: {
    ServiceOrderCreateOrderReviewTable,
  },
  computed: {
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServicePaymentRead extends Vue {
  isMounted = false;
  activeServicePayment!: Model;
  paymentStatuses = SERVICE_PAYMENT_STATUSES;
  paymentMethods = METHODS;
  paymentTransactionStatuses = STATUSES;
  serviceItems!: Model[];
  isSubmit = false;
  comment = '';
  showComment = false;
  isLoading = false;
  timer: NodeJS.Timeout | null = null;
  retryCount = 0;

  isApiFetch = {
    isApiFetchServicePaymentFinished: false,
  };

  beforeMount() {
    this.init();
  }

  async init() {
    this.retryCount = 0;
    this.isLoading = true;

    this.isApiFetch = {
      isApiFetchServicePaymentFinished: false,
    };

    while (this.retryCount < 5) {
      let oid;
      if (this.activeServicePayment) {
        oid = this.activeServicePayment.object_id;
      }
      if (this.$route.params.servicePaymentOid) {
        oid = this.$route.params.servicePaymentOid;
      }
      await this.$store.dispatch('ServicePayment/fetch', {
        oid: oid,
        params: {
          expand: ['service_items'],
        },
      });
      if (this.activeServicePayment.method == this.paymentMethods.INVOICE.key) {
        break;
      }
      if (!this.activeServicePayment._payment_transaction) {
        break;
      }
      if (
        [
          this.paymentTransactionStatuses.STATUS_SUCCEED.key,
          this.paymentTransactionStatuses.STATUS_FAILED.key,
        ].includes(this.activeServicePayment._payment_transaction.status)
      ) {
        break;
      }
      await this.wait(3000);
      this.retryCount += 1;
    }
    this.timer = null;
    this.isApiFetch['isApiFetchServicePaymentFinished'] = true;
    // .then(() => {
    //   this.isApiFetch["isApiFetchServicePaymentFinished"] = true
    // })
  }

  wait(ms) {
    return new Promise((resolve) => {
      this.timer = setTimeout(resolve, ms);
    });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }

      if (!isFinished) {
        return;
      }

      this.isMounted = true;
      this.isLoading = false;
    }
  }

  get isSucceed() {
    return (
      this.activeServicePayment._payment_transaction &&
      this.activeServicePayment._payment_transaction.status ===
        this.paymentTransactionStatuses.STATUS_SUCCEED.key
    );
  }

  get canMarkPaid() {
    return (
      this.activeServicePayment._payment_transaction &&
      this.activeServicePayment.method == this.paymentMethods.INVOICE.key &&
      [
        this.paymentStatuses.STATUS_UNPAID.key,
        this.paymentStatuses.STATUS_OVERDUE.key,
      ].includes(this.activeServicePayment.status)
    );
  }

  markPaid() {
    this.isSubmit = true;
    this.$store
      .dispatch('ServicePaymentTransaction/markInvoicePaid', {
        oid: this.activeServicePayment._payment_transaction.object_id,
        payload: {
          comment: this.comment,
        },
      })
      .then(() => {
        this.isSubmit = false;
        this.init();
      });
  }
}
